import Promise from 'promise-polyfill';

function loadStyle(url) {
	if (document.querySelector(`link[href="${url}"]`)) {
		return Promise.resolve();
	}

	const linkTag = document.createElement('link');
	linkTag.href = url;
	linkTag.rel = 'stylesheet';

	const globalCss = document.querySelectorAll('link[href*="/ui/"]');
	const lastGlobalCss = globalCss[globalCss.length - 1];
	lastGlobalCss.insertAdjacentElement('afterend', linkTag);

	// IE 11 does not support link tag onload callback, just resolving the promise for now
	return Promise.resolve();
}

export default loadStyle;
